module.exports = __webpack_public_path__ + "static/media/part6.a74c040c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/partners/part6.jpg
// module id = 107
// module chunks = 0